package one.healthium.data.user.dto

import dev.gitlive.firebase.firestore.Timestamp
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import one.healthium.common.serializers.SafeFloatSerializer

@Serializable
internal data class WeightLogDto(
    @SerialName(FIELD_DATE) val date: Timestamp,
    @SerialName("weight") @Serializable(with = SafeFloatSerializer::class) val weight: Float,
) {
    companion object {
        const val FIELD_DATE = "date"
    }
}
